export default {
    // START:: SET NOTIFICATIONS
    setWishlist(state, payload) {
        state.wishlist = payload;
    },
    // END:: SET NOTIFICATIONS
};